<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <router-outlet />
  </div>
  <div class="row row--primary">
    <div class="col-12 p-0">
      <web-components-user-messages />
    </div>
  </div>
</div>
